import React from "react";
import { Link as RouterLink } from "react-router-dom";

const Error404 = () => {
  return (
    <div className="mb-64">
      <div className="flex justify-center pt-32 px-auto md:p-0  error-mobile  error-font p-0">
        <p> 404</p>
      </div>
      <div className="flex justify-center md:text-3xl page-error n-green md:-mt-16">
        <p>Page Not Found</p>
      </div>
      <div className="flex justify-center pt-10  ">
        <button
          type="button"
          className="bg-white  border n-green w-32 text-lg rounded-lg p-2 focus:outline-none error-hover"
        >
          <RouterLink to="/">Home Page</RouterLink>
        </button>
      </div>
    </div>
  );
};
export default Error404;
